import { ConditionalLinkConditions } from '@sharefiledev/sharing-pilet-sdk/api';
import { PluginTFunction } from '../../utils';
import { ConditionOptionsProps } from '../ConditionalLinks/utils';

export const getConditionOptions = (
	availableConditions: ConditionalLinkConditions[],
	t: PluginTFunction
): ConditionOptionsProps[] => {
	const conditionOptions: ConditionOptionsProps[] = [];
	if (availableConditions.includes(ConditionalLinkConditions.Anonymous)) {
		conditionOptions.push({
			label: t('AccessOptions.conditionalOptions.anyonePublic'),
			value: ConditionalLinkConditions.Anonymous,
		});
	}
	if (availableConditions.includes(ConditionalLinkConditions.AnonymousWithUserInfo)) {
		conditionOptions.push({
			label: t('AccessOptions.conditionalOptions.anyonePublicWithInfo'),
			value: ConditionalLinkConditions.AnonymousWithUserInfo,
		});
	}
	if (
		availableConditions.includes(
			ConditionalLinkConditions.RequireLoginEmployeesAndClients
		)
	) {
		conditionOptions.push({
			label: t('AccessOptions.conditionalOptions.clientAndEmployeeUsers'),
			value: ConditionalLinkConditions.RequireLoginEmployeesAndClients,
		});
	}
	if (availableConditions.includes(ConditionalLinkConditions.RequireLoginEmployeesOnly)) {
		conditionOptions.push({
			label: t('AccessOptions.conditionalOptions.employeeUsersOnly'),
			value: ConditionalLinkConditions.RequireLoginEmployeesOnly,
		});
	}
	return conditionOptions;
};
